export function generateUID() {
  return "xxxx-xxxx-xxxx-xxxx".replace(/[x]/g, function () {
    return Math.floor(Math.random() * 16).toString(16);
  });
}
